export class PROTECTIONELEMENTSIDS {
  public static ANODE = '586ef87ca4d245e49e05202ff9041151'
  public static PROTECTION = '4e5f78cd5e5f40b4a4b56e2e76f8a0b6'
  public static PAINTING = '5b7494b9-5b47-4de4-9558-70cf8cdaddbd'

  public static asObject() {
    return {
      ANODE: PROTECTIONELEMENTSIDS.ANODE,
      PROTECTION: PROTECTIONELEMENTSIDS.PROTECTION,
      PAINTING: PROTECTIONELEMENTSIDS.PAINTING,
    }
  }
}
